<template>
  <div class="vendor-input">
    <input class="mr10" type="date" v-model="model_start" :disabled="disabled" />
    <input class="" type="date" v-model="model_end" :disabled="disabled" />
  </div>
</template>
<script>
export default {
  props: [
    'modelStart',
    'modelEnd',
    'list',
    'step',
    'i',
    'isRequired',
    'disabled',
  ],
  computed: {
    model_start: {
      get() {
        const data = this.$get(this.$store, `state.landingpage.${this.step}.${this.i + 2}.form_value`, '')
        return data
      },
      set(newValue) {
        this.$store.commit('landingpage/MD_STEP_UPDATE', {
          step: this.step,
          name: 'form_value',
          value: newValue,
          index: this.i + 2
        })
      },
    },
    model_end: {
      get() {
        const data = this.$get(this.$store, `state.landingpage.${this.step}.${this.i + 2}.form_sub_value`, '')
        return data
      },
      set(newValue) {
        this.$store.commit('landingpage/MD_STEP_UPDATE', {
          step: this.step,
          name: 'form_sub_value',
          value: newValue,
          index: this.i + 2
        })
      },
    },
  },
}
</script>
